import {AddColumnHeader} from '../../../../components/table/add-column-header'
import type {TableDataType} from '../../../../components/table/table-data-type'
import {AddColumnId} from '../../helpers/column-ids'
import type {ColumnDef} from '../../helpers/types'

/**
 * Non-field Tanstack table column definition for the right-side "[+] Add field" header button
 */
export const AddColumnHeaderColumnDef: ColumnDef<TableDataType> = {
  header: AddColumnHeader,
  id: AddColumnId,
  accessorKey: AddColumnId,
  size: 50,
  minSize: 50,
  enableResizing: false,
  meta: {
    columnModel: undefined,
    Cell: () => null,
    nonNavigable: true,
    typeToEditEnabled: false,
  },
}
